export default "__VITE_ASSET__Bfxm0fpn__"